import attributeLogo from 'assets/modal-icons/attribute.svg';
import reachableLogo from 'assets/modal-icons/reachable.svg';
import tagsLogo from 'assets/modal-icons/tags.svg';
import platformsLogo from 'assets/modal-icons/platforms.svg';
import { FILTER_TYPES, FilterType } from '@mm/state/model/AudiencesModel';

export const FILTERS_WITH_DETAILS: Partial<Record<FilterType, any>> = {
  [FILTER_TYPES.variableValues]: {
    // Note: Keeping type for ease of later user,
    // though technically it is a duplicate of the key.
    type: FILTER_TYPES.variableValues,
    logo: attributeLogo,
    title: 'Filter by attribute',
    description:
      'Only include contacts with certain values for a system or custom attribute of your choice',
    pro: false,
  },
  [FILTER_TYPES.tags]: {
    type: FILTER_TYPES.tags,
    logo: tagsLogo,
    title: 'Filter by tag',
    description: 'Only include contacts who have been assigned a chosen tag',
    pro: false,
  },
  [FILTER_TYPES.tagsFilters]: {
    type: FILTER_TYPES.tagsFilters,
    logo: tagsLogo,
    title: 'Filter by tag',
    description: 'Only include contacts who have been assigned a chosen tag',
    pro: false,
  },
  [FILTER_TYPES.reachable]: {
    type: FILTER_TYPES.reachable,
    logo: reachableLogo,
    title: 'Filter by active within 24 hours',
    /* tslint:disable */
    description:
      'Contacts to whom you may send promotional content based on the 24+1 rule: users who have messaged your page in the past 24 hours or have not been sent a single promotional message since their last message',
    /* tslint:enable */
    pro: false,
  },
  [FILTER_TYPES.platforms]: {
    type: FILTER_TYPES.platforms,
    logo: platformsLogo,
    title: 'Filter by platform',
    description: '',
    pro: false,
  },
  [FILTER_TYPES.euLimits]: {
    type: FILTER_TYPES.euLimits,
    logo: platformsLogo,
    title: 'Filter by EU Membership',
    description: '',
    pro: false,
  },
};

export const getFilterDetailsByType = (type: FilterType) => {
  return FILTERS_WITH_DETAILS[type];
};
